/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import "./LeadForm.css";
import "react-phone-number-input/style.css";
import React, {
  // Fragment,
  useEffect,
  useState,

  // useRef
} from "react";
import { useForm } from "react-hook-form";

import { isValidPhoneNumber } from "react-phone-number-input";
import PhoneInputWithCountry from "react-phone-number-input/react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import CreateLeads from "../../controllers/leads/CreateLeads";
import Modal from "@mui/material/Modal";
import NumberFormat from "react-number-format";
import { ToastSuccessMessages } from "../../controllers/auth/AuthErrorMessages";
import UpdateSingleLead from "../../controllers/leads/UpdateSingleLead";
import isDuplicatePhoneNumber from "../../controllers/duplicates/isDuplicatePhoneNumber";
import isDuplicateCNIC from "../../controllers/duplicates/isDuplicateCNIC";
import PlacesAutocomplete, {
  geocodeByAddress,
} from "react-places-autocomplete";

// Form Validate schema Start
const schema = yup.object().shape({
  name: yup
    .string()
    .min(3, "Name must have at least 3 characters")
    .max(30, "Name must not be more than 30 characters")
    .required("Name is required")
    .default(""),
  phone: yup.string().required("Phone number is required").nullable(),
  email: yup.string().email("Invalid email").default(null).nullable(),
  company: yup.string().default(null).nullable(),
  cnic: yup.string().default(null).nullable(),
  address: yup
    .string()
    .max(500, "Address must not be more than 500 characters")
    .default(null)
    .nullable(),
});

export default function LeadForm(props) {
  const { open, setOpen, SingleLeadData, LeadId, handleRefresh } = props;
  const [number, setNumber] = useState(SingleLeadData?.phone);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    setError,
    control,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (open === "update") {
      setValue("name", SingleLeadData?.name);
      setValue("phone", SingleLeadData?.phone);
      setValue("email", SingleLeadData?.email);
      setValue("company", SingleLeadData?.company);
      setValue("cnic", SingleLeadData?.cnic);
      setValue("address", SingleLeadData?.address);
      setAddress(SingleLeadData?.address ?? "");
    }
  }, [open, SingleLeadData]);

  const [isDisabled, setIsDisabled] = useState(false);
  const [address, setAddress] = useState("");
  // const [citySelected, setSelectedCity2] = useState("");
  const handleSelect = async (value) => {
    setAddress(value);
    setValue("address", value);
  };
  const handleClose = () => {
    setValue("name", "");
    setValue("phone", "");
    setValue("email", null);
    setValue("company", null);
    setValue("cnic", null);
    setValue("address", null);
    setOpen(false);
    setIsDisabled(false);
    setError("cnic", {
      message: "",
    });
    setError("phone", {
      message: "",
    });
    setError("name", {
      message: "",
    });
    setError("email", {
      message: "",
    });
  };

  const submitForm = async (e, LeadId) => {
    setIsDisabled(true);

    // console.log(e);
    const clientData = {
      name: e.name,
      phone: e.phone,
      email: e.email === "" ? null : e.email,
      company: e.company === "" ? null : e.company,
      cnic: e.cnic === "" ? null : e.cnic,
      address: e.address === "" ? null : e.address,
    };

    //this conditions checks if the submit form is used to update or add a lead
    if (LeadId) {
      //updating the lead
      setIsDisabled(true);

      //no duplication check if the user entered the same number
      if (clientData.phone !== SingleLeadData.phone) {
        if (
          clientData.phone !== "" ||
          clientData.phone !== null ||
          clientData.phone !== undefined
        ) {
          if (isValidPhoneNumber(clientData.phone)) {
            // console.log("Checking duplicate phone ...");
            //checking for duplicates
            if (await isDuplicatePhoneNumber(clientData.phone)) {
              setError("phone", {
                message:
                  "This phone number already exists! use a different phone number ",
              });
              setIsDisabled(false);
              return;
            }
          } else {
            setError("phone", {
              message: "Enter a valid phone number",
            });
            setIsDisabled(false);
            return;
          }
        } else {
          setError("phone", {
            message: "Phone Number is required",
          });
          setIsDisabled(false);
          return;
        }
      }
      if (clientData.cnic !== SingleLeadData.cnic) {
        if (clientData.cnic !== null) {
          if (clientData.cnic.length < 13) {
            setError("cnic", {
              message: "CNIC must be 13 digits",
            });
            setIsDisabled(false);
            return;
          } else if (await isDuplicateCNIC(clientData.cnic)) {
            setError("cnic", {
              message:
                "This cnic number already exists! use a different cnic number ",
            });
            setIsDisabled(false);
            return;
          }
        }
      }

      const leads = await UpdateSingleLead(clientData, LeadId);
      if (leads !== null) {
        reset();
        setIsDisabled(false);
        handleClose();
        ToastSuccessMessages("lead/updating-successful");
        handleRefresh();
      } else {
        setValue("cnic", null);
        setError("cnic", {
          type: "required",
          message: "CNIC already exists!",
        });
        setIsDisabled(false);
        return;
      }
    } else {
      //adding new lead
      setIsDisabled(true);
      //console.log("Creating lead ...");

      //error handling

      if (
        clientData.phone !== "" ||
        clientData.phone !== null ||
        clientData.phone !== undefined
      ) {
        if (isValidPhoneNumber(clientData.phone)) {
          // console.log("Checking duplicate phone ...");
          if (await isDuplicatePhoneNumber(clientData.phone)) {
            setError("phone", {
              message: "Phone already exists!",
            });
            setIsDisabled(false);
            return;
          }
        } else {
          setError("phone", {
            message: "Enter a valid phone number",
          });
          setIsDisabled(false);
          return;
        }
      } else {
        setError("phone", {
          message: "phone number is required",
        });
        setIsDisabled(false);
        return;
      }

      if (clientData.cnic !== null) {
        if (clientData.cnic.length < 13) {
          setError("cnic", {
            message: "CNIC must be 13 digits",
          });
          setIsDisabled(false);
          return;
        } else {
          // console.log("Checking duplicate cnic ...");
          if (await isDuplicateCNIC(clientData.cnic)) {
            setError("cnic", {
              message: "CNIC already exists! Use different cnic",
            });
            setIsDisabled(false);
            return;
          }
        }
      }

      // console.log("naway data", clientData);

      const leads = await CreateLeads(clientData);
      if (leads !== null) {
        reset();
        setIsDisabled(false);
        ToastSuccessMessages("lead/creation-successful");
        handleRefresh();
      } else {
        setIsDisabled(false);
        return;
      }
      handleClose();
    }
  };

  useEffect(() => {
    //console.log(watch());
  }, [watch]);

  return (
    <Modal
      open={open ? true : false}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="ModalStyle add-edit-client-modal"
    >
      <div className="modal-dialog modal-lg">
        <div className="lead-modal-content modal-content">
          <div className="modal-header">
            <h3 className="modal-heading">
              {open === "add" ? "Add Client" : "Update Client"}
            </h3>
            <button
              type="button"
              className="close add-edit-client-modal-close-button"
              onClick={handleClose}
            >
              <span>&times;</span>
            </button>
          </div>
          <form className="modal-body lead-form-modal-body">
            <div className="form-row">
              <div className="form-group col-12">
                <label className="modal-form-field-label">
                  Name <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  autoFocus
                  className="form-control form-input-field"
                  {...register("name")}
                  onChange={(e) => {
                    let words = e.target.value.split(" ");
                    for (let i = 0; i < words.length; i++) {
                      words[i] =
                        words[i][0].toUpperCase() +
                        words[i].slice(1).toLowerCase();
                    }
                    setValue("name", words.join(" "));
                  }}
                  disabled={isDisabled}
                  defaultValue={SingleLeadData?.name}
                />
                <p className="errorMessage lead-form-error-message">
                  {" "}
                  {errors.name?.message}{" "}
                </p>
              </div>
            </div>

            <div className="form-row phone-row">
              <div className="form-group col-12">
                <label className="modal-form-field-label">
                  Phone <span style={{ color: "red" }}>*</span>
                </label>
                <PhoneInputWithCountry
                  name="phone"
                  className="form-phone-input-field"
                  defaultCountry={"PK"}
                  international={true}
                  countryCallingCodeEditable={false}
                  initialValueFormat="national"
                  control={control}
                  disabled={isDisabled}
                  defaultValue={number}
                  rules={{
                    validate: (value) => isValidPhoneNumber(value),
                    required: true,
                  }}
                  style={{ border: "none !important" }}
                />

                {/* <NumberFormat
                  format="#### #######"
                  // allowEmptyFormatting={" "}
                  // mask=" "
                  type="text"
                  className="form-control input-style"
                  placeholder="03** *******"
                  name="phone"
                  defaultValue={SingleLeadData?.phone}
                  {...register("phone")}
                  onChange={(e) =>
                    setValue("phone", e.target.value.replaceAll(" ", "").trim())
                  }
                  // value={Phone}
                  // {...phoneRegister("phone", { required: true })}
                  disabled={isDisabled}
                /> */}
                {/* <input
                      type="text"
                      name="phone"
                      placeholder="XXXX XXXXXXX"
                      data-inputmask="'mask': '9999 9999999'"
                      className="form-control input-style"
                      pattern="^[0-9]{4} [0-9]{7}$"
                      // required
                      id="phone"
                      // value={PhoneNumber}
                      disabled={isDisabled}
                      {...register("phone")}
                      // onChange={(e) => setPhoneNumber(e.target.value)}
                    /> */}

                <p className="errorMessage lead-form-error-message">
                  {errors.phone?.message}{" "}
                </p>
              </div>
            </div>

            <div className="form-row ">
              <div className="form-group col-12">
                <label className="modal-form-field-label">Email</label>
                <input
                  type="text"
                  name="email"
                  onFocus={(e) => (e.target.type = "email")}
                  className="form-control form-input-field"
                  {...register("email")}
                  defaultValue={SingleLeadData?.email}
                  disabled={isDisabled}
                />
                <p className="errorMessage"> {errors.email?.message} </p>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-12">
                <label className="modal-form-field-label">Company</label>
                <input
                  type="text"
                  name="company"
                  className="form-control form-input-field"
                  {...register("company")}
                  onChange={(e) => {
                    let words = e.target.value.split(" ");
                    for (let i = 0; i < words.length; i++) {
                      words[i] =
                        words[i][0].toUpperCase() +
                        words[i].slice(1).toLowerCase();
                    }
                    setValue("company", words.join(" "));
                  }}
                  defaultValue={SingleLeadData?.company}
                  disabled={isDisabled}
                />
                <p className="errorMessage"> {errors.company?.message} </p>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-12">
                <label className="modal-form-field-label">CNIC</label>

                <NumberFormat
                  format="#####-#######-#"
                  // allowEmptyFormatting={" "}
                  // mask=" "
                  type="text"
                  className="form-control form-input-field"
                  placeholder="#####-#######-#"
                  defaultValue={SingleLeadData?.cnic}
                  name="cnic"
                  {...register("cnic")}
                  onChange={(e) => {
                    setValue("cnic", e.target.value.replaceAll("-", "").trim());
                  }}
                  // onChange={(e) => setValue("cnic", e.target.value)}
                  // value={Phone}
                  // {...phoneRegister("phone", { required: true })}
                  disabled={isDisabled}
                />

                <p className="errorMessage">{errors.cnic?.message} </p>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-12">
                <label className="modal-form-field-label">Address</label>
                {/* <input
                  type="text"
                  name="address"
                  className="form-control input-style"
                  {...register("address")}
                  onChange={(e) => {
                    setValue(
                      "address",
                      e.target.value.charAt(0).toUpperCase() +
                        e.target.value.slice(1).toLowerCase()
                    );
                  }}
                  defaultValue={SingleLeadData?.address}
                  disabled={isDisabled}
                /> */}
                <div className="div-autocomplete">
                  <PlacesAutocomplete
                    value={address}
                    onChange={(e) => {
                      setAddress(e);
                      setValue("address", e);
                    }}
                    onSelect={handleSelect}
                    searchOptions={{ componentRestrictions: { country: "pk" } }}
                    // className="loc-auto-complete-client"
                  >
                    {({
                      getInputProps,
                      suggestions,
                      getSuggestionItemProps,
                      loading,
                    }) => (
                      <div>
                        <input
                          className="location-input-style"
                          {...getInputProps({ placeholder: "Address" })}
                        />

                        <div>
                          {loading ? (
                            <div className="loc-auto-complete-content">
                              loading...
                            </div>
                          ) : null}

                          {suggestions.map((suggestion) => {
                            const style = {
                              backgroundColor: suggestion.active
                                ? "#c9c2e4"
                                : "#fff",
                            };

                            return (
                              <div
                                className="loc-auto-complete-content"
                                {...getSuggestionItemProps(suggestion, {
                                  style,
                                })}
                              >
                                {suggestion.description}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </PlacesAutocomplete>
                </div>

                <p className="errorMessage"> {errors.address?.message} </p>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="mr-3 btn btn-outline-danger light"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleSubmit((e) => {
                  if (open === "add") {
                    submitForm(e);
                  } else {
                    submitForm(e, LeadId);
                  }
                })}
                className="add-edit-client-button"
                disabled={isDisabled}
              >
                {isDisabled && (
                  <span className="spinner-border spinner-border-sm mr-1"></span>
                )}
                {open === "add" ? " Create" : "Update"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
